import React from 'react'
import Journal from './Journal'
import Reports from './Reports'

const JournalReport = ({ activeComponent }) => {
  return (
    <>
      {activeComponent === 'journal' && <Journal />}
      {activeComponent === 'report' && <Reports />}
    </>
  )
}

export default JournalReport